import { Button } from '@mui/material'
import { NavigationState } from 'element-domain/src/__generated/application-types'
import type { $Table } from 'element-domain/src/__generated/enhanced-model'
import React from 'react'

import { configuratorInterface } from '../../../systems/configurator-interface'

type RequestQuoteButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  title: string
  table: $Table
  style?: React.CSSProperties
}

export const RequestQuoteButton: React.FC<RequestQuoteButtonProps> = ({ title, style }) => {
  const { navigationSystem, storeSystem } = configuratorInterface.useDomain()

  function handleClick() {
    storeSystem.stageAndCommit([
      navigationSystem.getPushNavigationUpdate(
        NavigationState.FinalizeQuote,
        storeSystem.stateSlices.committed.value.state
      ),
    ])
  }
  return (
    <Button variant="outlined" onClick={handleClick} style={style}>
      {title}
    </Button>
  )
}
